module.exports = __webpack_public_path__ + "img/pantalla 4-1 mobile.59d5cd59.svg";